export var WEEKDAYS_LONG = ['Zondag', 'Maandag', 'Dinsday', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'];
export var WEEKDAYS_SHORT = ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'];